// prod
export const API_URL = 'https://cregger.copperpress.tech/api/';

// dev
// export const API_URL = 'http://127.0.0.1:8002/api/';
